import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ScreensQuestionResource } from '@Components/mras/core';

@Component({
    selector: 'jhi-picklist-input',
    templateUrl: './picklist-input.component.html'
})
export class PicklistInputComponent implements OnInit, OnChanges {
    @Input() question: ScreensQuestionResource;
    @Input()
        value: string;
    @Output()
        valueChange = new EventEmitter<string>();

    @Input()
        summaryMode: boolean;

    @Input()
        name: string;
    @Input()
        options: string[];
    @Output()
        action = new EventEmitter();

    checkboxValue: string[] = [];

    @Input()
        showNoneOfTheAbove: boolean;
    @Input()
        bqAnswer: string;
    noneOfTheAbove: boolean;

    constructor() {}

    ngOnInit(): void {
        this.options.forEach(e => {
            this.checkboxValue[e] = false;
        });
        if (this.value != null && this.value.trim().length > 0) {
            this.value
                .split(',')
                .filter(e => e != null)
                .forEach(e => {
                    this.checkboxValue[e] = true;
                });
        }
        
        if (this.bqAnswer && this.bqAnswer === 'false')
            this.noneOfTheAbove = true;   
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.options.forEach(e => {
            this.checkboxValue[e] = false;
        });
        if (this.value != null && this.value.trim().length > 0) {
            this.value
                .split(',')
                .filter(e => e != null)
                .forEach(e => {
                    this.checkboxValue[e] = true;
                });
        }
    }

    onClick(name: string) {
        if (this.value && this.value !== '') {
            this.valueChange.emit(null);
        }

        if (this.question.invalid) {
            this.question.invalid = false;
        }

        this.value = Object.keys(this.checkboxValue)
            .filter(e => e != null)
            .filter(e => this.checkboxValue[e] === true)
            .join(',');
        this.valueChange.emit(this.value);
        this.action.emit({
            name,
            value: this.checkboxValue[name]
        });
    }

    onNoneClick(name: string) {
        this.action.emit({
            name,
            value: String(!this.noneOfTheAbove)
        });
    }
}
